import { seoArticles } from "@/mocks/articles";

export default function ArticlePreviews() {
  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Mulebuy Spreadsheet Guides & Articles
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg">
            Explore our collection of in-depth guides covering everything from beginner tutorials to advanced spreadsheet strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {seoArticles.map((article) => (
            <a
              key={article.slug}
              href={`/blog/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-white/90 text-foreground-800 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                  <span className="flex items-center gap-1 text-primary-600 text-xs font-medium group-hover:gap-2 transition-all">
                    Read More
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </div>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}